// extracted by mini-css-extract-plugin
export var animationContainer = "_fk-0";
export var asteriskIcon = "_fk-8";
export var conversationLeftSection = "_fk-4";
export var conversationListItem = "_fk-3";
export var conversationMiddleSection = "_fk-5";
export var conversationRightSection = "_fk-6";
export var detailsContent = "_fk-1";
export var listContainer = "_fk-7";
export var modalContent = "_fk-2";